<template>
    <div class="torreairea_torre">

        <div v-if="loadFilters" class="custom__filters-torres" style="">
            <button-back class="custom__filters-torres-back" />
            <Availables class="availables-desk availables-torreairea custom__filters-torres-filter"
                :desarrollo="desarrollo" :type="type" :existFilter="existFilter" :filterPrice="rangeFilterPrice"
                :filterPriceDtos="rangeFilterPrices" @onUpdateModel="updateActiveModel" @defaultDetail="hideDetail" />
        </div>
        <Availables v-if="loadFilters" class="availables-mobile torreairea" :desarrollo="desarrollo" :type="type"
            :existFilter="existFilter" :filterPrice="rangeFilterPrice" :filterPriceDtos="rangeFilterPrices"
            @onUpdateModel="updateActiveModel" @defaultDetail="hideDetail" />

        <div v-if="locations.length > 0" class="map_filter">
            <div class="maphighlight__box torreairea torrespp-design" :class="{ 'show-detail': detailPiso }">
                <h1 class="caption__select">
                    <span>{{ img.name }}</span>
                    <span></span>
                </h1>
                <div class="content__depto">
                    <map-highlight-deptos class="canadas_line" :defaultActive="detailPiso" :indicators="indicators"
                        @activeDetail="showDetailPiso" :torreLevel="levelTorre" :img="img" :existFilter="existFilter"
                        :desarrollo="desarrollo" :url="url" :type="type" :nivel="nivel" />

                    <div class="content-loader detail-piso" v-if="loadElement">
                        <div class="loading__box">
                            <div class="loading show">
                                <div class="spin"></div>
                            </div>
                        </div>
                    </div>
                    <div v-show="detailPiso && !loadElement" class="detail-piso">
                        <Pisos @activeDetailPiso="showDetail" />
                    </div>
                    <div v-show="!detailPiso && !loadElement" class="detail-piso">
                        <h1 class="caption__select ">
                            <span>Seleccione un nivel, clic para ver detalles</span>
                        </h1>
                    </div>
                </div>
                <div class="line_horizontal" v-if="detailPiso"></div>

            </div>
            <div class="select__box torrea" v-show="detailPiso">
                <div v-show="!detail">
                    <h1 class="caption__select torrea">
                        <span>Seleccione un departamento, clic para ver detalles</span>
                    </h1>
                </div>
                <div v-show="detail">
                    <Buttons />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import MapHighlightDeptos from "../../../core/rediseno/MapHighlightDeptosAirea.vue";
import ButtonBack from "../../../core/ButtonBack";
import Availables from "../../../core/rediseno/Availables.vue";
import Pisos from "./Piso.vue"
import Buttons from "./Model.vue"

export default {
    name: "Main",
    components: {
        MapHighlightDeptos,
        ButtonBack,
        Availables,
        Pisos,
        Buttons
    },
    data() {
        return {
            id: this.$route.params.id,
            levelId: 0,
            //this add
            levelTorre: 35,
            //normal
            type: "departamentos",
            desarrollo: "canadas_deptos",
            arrFilteredLocations: [],
            nivel: "towerStageLevel",
            url: `cve_torre_etapa=${this.$route.params.id}`,
            micrositeUrl: "https://www.tresmarias.com.mx/senderos/terrenos",
            torres: {
                TORRE1: {
                    name: 'TORRE 1',
                    url: 'https://kiritek-web-documents.s3.us-west-2.amazonaws.com/masterplan-dashboard/imgs/ca%C3%B1adas/deptos/fachadaPrincipalNueva.png',
                    width: '3500',
                    id: this.$route.params.id,
                    levelId: 0,
                    nivel: 'towerStageLevel',
                    route: `cve_torre_etapa=${this.$route.params.id}`,
                    height: '1969',
                    transform: '',
                    viewBox: '0 0 3500 1969'
                },
                TORRE2: {
                    name: 'TORRE 2',
                    url: 'https://kiritek-web-documents.s3.us-west-2.amazonaws.com/masterplan-dashboard/imgs/ca%C3%B1adas/deptos/fachadaPrincipalNueva.png',
                    width: '3500',
                    id: this.$route.params.id,
                    levelId: 0,
                    nivel: 'towerStageLevel',
                    route: `cve_torre_etapa=${this.$route.params.id}`,
                    height: '1969',
                    transform: '',
                    viewBox: '0 0 3500 1969'
                },
                TORRE3: {
                    name: 'TORRE 3',
                    url: 'https://kiritek-web-documents.s3.us-west-2.amazonaws.com/masterplan-dashboard/imgs/ca%C3%B1adas/deptos/fachadaPrincipalNueva.png',
                    width: '3500',
                    id: this.$route.params.id,
                    levelId: 0,
                    nivel: 'towerStageLevel',
                    route: `cve_torre_etapa=${this.$route.params.id}`,
                    height: '1969',
                    transform: '',
                    viewBox: '0 0 3500 1969'
                },
                TORRE4: {
                    name: 'TORRE 4',
                    url: 'https://kiritek-web-documents.s3.us-west-2.amazonaws.com/masterplan-dashboard/imgs/ca%C3%B1adas/deptos/fachadaPrincipalNuevaTorreN2.png',
                    width: '3500',
                    id: this.$route.params.id,
                    levelId: 0,
                    nivel: 'towerStageLevel',
                    route: `cve_torre_etapa=${this.$route.params.id}`,
                    height: '1969',
                    transform: '',
                    viewBox: '0 0 3500 1969'
              },
                TORRE5: {
                    name: 'TORRE 5',
                    url: 'https://kiritek-web-documents.s3.us-west-2.amazonaws.com/masterplan-dashboard/imgs/ca%C3%B1adas/deptos/fachadaPrincipalNuevaTorreN2.png',
                    width: '3500',
                    id: this.$route.params.id,
                    levelId: 0,
                    nivel: 'towerStageLevel',
                    route: `cve_torre_etapa=${this.$route.params.id}`,
                    height: '1969',
                    transform: '',
                    viewBox: '0 0 3500 1969'
              },
                TORRE6: {
                    name: 'TORRE 6',
                    url: 'https://kiritek-web-documents.s3.us-west-2.amazonaws.com/masterplan-dashboard/imgs/ca%C3%B1adas/deptos/fachadaPrincipalNueva.png',
                    width: '3500',
                    id: this.$route.params.id,
                    levelId: 0,
                    nivel: 'towerStageLevel',
                    route: `cve_torre_etapa=${this.$route.params.id}`,
                    height: '1969',
                    transform: '',
                    viewBox: '0 0 3500 1969'
                },
                TORRE7: {
                    name: 'TORRE 7',
                    url: 'https://kiritek-web-documents.s3.us-west-2.amazonaws.com/masterplan-dashboard/imgs/ca%C3%B1adas/deptos/fachadaPrincipalNueva.png',
                    width: '3500',
                    id: this.$route.params.id,
                    levelId: 0,
                    nivel: 'towerStageLevel',
                    route: `cve_torre_etapa=${this.$route.params.id}`,
                    height: '1969',
                    transform: '',
                    viewBox: '0 0 3500 1969'
                },
                TORRE8: {
                    name: 'TORRE 8',
                    url: 'https://kiritek-web-documents.s3.us-west-2.amazonaws.com/masterplan-dashboard/imgs/ca%C3%B1adas/deptos/fachadaPrincipalNueva.png',
                    width: '3500',
                    id: this.$route.params.id,
                    levelId: 0,
                    nivel: 'towerStageLevel',
                    route: `cve_torre_etapa=${this.$route.params.id}`,
                    height: '1969',
                    transform: '',
                    viewBox: '0 0 3500 1969'
                },
            },
            // si no hay filtro volver rangeFilter a false
            rangeFilter: false,
            activeModel: "",
            detailPiso: false,
            detail: false,
            indicators: [
                { id: 250, text: 'PB', transform: 'matrix(1 0 0 1 260 1852)', cxB: 480.71, cyB: 300.62, rB: 10.29, cxW: 480.71, cyW: 300.62, rW: 5.29, x1: 0, y1: 0, x2: 0, y2: 0, status: true, class: "indicator_canadas indicator_letter" },
                { id: 251, text: '1', transform: 'matrix(1 0 0 1 300 1622)', cxB: 480.71, cyB: 300.62, rB: 10.29, cxW: 480.71, cyW: 300.62, rW: 5.29, x1: 402, y1: 1620.62, x2: 780, y2: 1620.62, status: true, class: "indicator_canadas" },
                { id: 252, text: '2', transform: 'matrix(1 0 0 1 300 1342)', cxB: 480.71, cyB: 300.62, rB: 10.29, cxW: 480.71, cyW: 300.62, rW: 5.29, x1: 402, y1: 1340.62, x2: 780, y2: 1340.62, status: true, class: "indicator_canadas" },
                { id: 253, text: '3', transform: 'matrix(1 0 0 1 300 1050)', cxB: 480.71, cyB: 300.62, rB: 10.29, cxW: 480.71, cyW: 300.62, rW: 5.29, x1: 402, y1: 1060.62, x2: 780, y2: 1060.62, status: true, class: "indicator_canadas" },
                { id: 254, text: '4', transform: 'matrix(1 0 0 1 300 772)', cxB: 480.71, cyB: 300.62, rB: 10.29, cxW: 480.71, cyW: 300.62, rW: 5.29, x1: 402, y1: 780.62, x2: 780, y2: 780.62, status: true, class: "indicator_canadas" },
                { id: 255, text: 'PB', transform: 'matrix(1 0 0 1 260 1852)', cxB: 480.71, cyB: 300.62, rB: 10.29, cxW: 480.71, cyW: 300.62, rW: 5.29, x1: 0, y1: 0, x2: 0, y2: 0, status: true, class: "indicator_canadas indicator_letter" },
                { id: 256, text: '1', transform: 'matrix(1 0 0 1 300 1622)', cxB: 480.71, cyB: 300.62, rB: 10.29, cxW: 480.71, cyW: 300.62, rW: 5.29, x1: 402, y1: 1620.62, x2: 780, y2: 1620.62, status: true, class: "indicator_canadas" },
                { id: 257, text: '2', transform: 'matrix(1 0 0 1 300 1342)', cxB: 480.71, cyB: 300.62, rB: 10.29, cxW: 480.71, cyW: 300.62, rW: 5.29, x1: 402, y1: 1340.62, x2: 780, y2: 1340.62, status: true, class: "indicator_canadas" },
                { id: 258, text: '3', transform: 'matrix(1 0 0 1 300 1050)', cxB: 480.71, cyB: 300.62, rB: 10.29, cxW: 480.71, cyW: 300.62, rW: 5.29, x1: 402, y1: 1060.62, x2: 780, y2: 1060.62, status: true, class: "indicator_canadas" },
                { id: 259, text: '4', transform: 'matrix(1 0 0 1 300 772)', cxB: 480.71, cyB: 300.62, rB: 10.29, cxW: 480.71, cyW: 300.62, rW: 5.29, x1: 402, y1: 780.62, x2: 780, y2: 780.62, status: true, class: "indicator_canadas" },
                { id: 276, text: 'PB', transform: 'matrix(1 0 0 1 260 1852)', cxB: 480.71, cyB: 300.62, rB: 10.29, cxW: 480.71, cyW: 300.62, rW: 5.29, x1: 0, y1: 0, x2: 0, y2: 0, status: true, class: "indicator_canadas indicator_letter" },
                { id: 277, text: '1', transform: 'matrix(1 0 0 1 300 1622)', cxB: 480.71, cyB: 300.62, rB: 10.29, cxW: 480.71, cyW: 300.62, rW: 5.29, x1: 402, y1: 1620.62, x2: 780, y2: 1620.62, status: true, class: "indicator_canadas" },
                { id: 278, text: '2', transform: 'matrix(1 0 0 1 300 1342)', cxB: 480.71, cyB: 300.62, rB: 10.29, cxW: 480.71, cyW: 300.62, rW: 5.29, x1: 402, y1: 1340.62, x2: 780, y2: 1340.62, status: true, class: "indicator_canadas" },
                { id: 279, text: '3', transform: 'matrix(1 0 0 1 300 1050)', cxB: 480.71, cyB: 300.62, rB: 10.29, cxW: 480.71, cyW: 300.62, rW: 5.29, x1: 402, y1: 1060.62, x2: 780, y2: 1060.62, status: true, class: "indicator_canadas" },
                { id: 280, text: '4', transform: 'matrix(1 0 0 1 300 772)', cxB: 480.71, cyB: 300.62, rB: 10.29, cxW: 480.71, cyW: 300.62, rW: 5.29, x1: 402, y1: 780.62, x2: 780, y2: 780.62, status: true, class: "indicator_canadas" },
                { id: 281, text: 'PB', transform: 'matrix(1 0 0 1 260 1852)', cxB: 480.71, cyB: 300.62, rB: 10.29, cxW: 480.71, cyW: 300.62, rW: 5.29, x1: 0, y1: 0, x2: 0, y2: 0, status: true, class: "indicator_canadas indicator_letter" },
                { id: 282, text: '1', transform: 'matrix(1 0 0 1 300 1622)', cxB: 480.71, cyB: 300.62, rB: 10.29, cxW: 480.71, cyW: 300.62, rW: 5.29, x1: 402, y1: 1620.62, x2: 780, y2: 1620.62, status: true, class: "indicator_canadas" },
                { id: 283, text: '2', transform: 'matrix(1 0 0 1 300 1342)', cxB: 480.71, cyB: 300.62, rB: 10.29, cxW: 480.71, cyW: 300.62, rW: 5.29, x1: 402, y1: 1340.62, x2: 780, y2: 1340.62, status: true, class: "indicator_canadas" },
                { id: 284, text: '3', transform: 'matrix(1 0 0 1 300 1050)', cxB: 480.71, cyB: 300.62, rB: 10.29, cxW: 480.71, cyW: 300.62, rW: 5.29, x1: 402, y1: 1060.62, x2: 780, y2: 1060.62, status: true, class: "indicator_canadas" },
                { id: 285, text: '4', transform: 'matrix(1 0 0 1 300 772)', cxB: 480.71, cyB: 300.62, rB: 10.29, cxW: 480.71, cyW: 300.62, rW: 5.29, x1: 402, y1: 780.62, x2: 780, y2: 780.62, status: true, class: "indicator_canadas" },
                { id: 311, text: 'PB', transform: 'matrix(1 0 0 1 260 1852)', cxB: 480.71, cyB: 300.62, rB: 10.29, cxW: 480.71, cyW: 300.62, rW: 5.29, x1: 0, y1: 0, x2: 0, y2: 0, status: true, class: "indicator_canadas indicator_letter" },
                { id: 312, text: '1', transform: 'matrix(1 0 0 1 300 1622)', cxB: 480.71, cyB: 300.62, rB: 10.29, cxW: 480.71, cyW: 300.62, rW: 5.29, x1: 402, y1: 1620.62, x2: 780, y2: 1620.62, status: true, class: "indicator_canadas" },
                { id: 313, text: '2', transform: 'matrix(1 0 0 1 300 1342)', cxB: 480.71, cyB: 300.62, rB: 10.29, cxW: 480.71, cyW: 300.62, rW: 5.29, x1: 402, y1: 1340.62, x2: 780, y2: 1340.62, status: true, class: "indicator_canadas" },
                { id: 314, text: '3', transform: 'matrix(1 0 0 1 300 1050)', cxB: 480.71, cyB: 300.62, rB: 10.29, cxW: 480.71, cyW: 300.62, rW: 5.29, x1: 402, y1: 1060.62, x2: 780, y2: 1060.62, status: true, class: "indicator_canadas" },
                { id: 315, text: '4', transform: 'matrix(1 0 0 1 300 772)', cxB: 480.71, cyB: 300.62, rB: 10.29, cxW: 480.71, cyW: 300.62, rW: 5.29, x1: 402, y1: 780.62, x2: 780, y2: 780.62, status: true, class: "indicator_canadas" },
                { id: 317, text: 'PB', transform: 'matrix(1 0 0 1 260 1852)', cxB: 480.71, cyB: 300.62, rB: 10.29, cxW: 480.71, cyW: 300.62, rW: 5.29, x1: 0, y1: 0, x2: 0, y2: 0, status: true, class: "indicator_canadas indicator_letter" },
                { id: 318, text: '1', transform: 'matrix(1 0 0 1 300 1622)', cxB: 480.71, cyB: 300.62, rB: 10.29, cxW: 480.71, cyW: 300.62, rW: 5.29, x1: 402, y1: 1620.62, x2: 780, y2: 1620.62, status: true, class: "indicator_canadas" },
                { id: 319, text: '2', transform: 'matrix(1 0 0 1 300 1342)', cxB: 480.71, cyB: 300.62, rB: 10.29, cxW: 480.71, cyW: 300.62, rW: 5.29, x1: 402, y1: 1340.62, x2: 780, y2: 1340.62, status: true, class: "indicator_canadas" },
                { id: 320, text: '3', transform: 'matrix(1 0 0 1 300 1050)', cxB: 480.71, cyB: 300.62, rB: 10.29, cxW: 480.71, cyW: 300.62, rW: 5.29, x1: 402, y1: 1060.62, x2: 780, y2: 1060.62, status: true, class: "indicator_canadas" },
                { id: 321, text: '4', transform: 'matrix(1 0 0 1 300 772)', cxB: 480.71, cyB: 300.62, rB: 10.29, cxW: 480.71, cyW: 300.62, rW: 5.29, x1: 402, y1: 780.62, x2: 780, y2: 780.62, status: true, class: "indicator_canadas" },
                { id: 322, text: 'PB', transform: 'matrix(1 0 0 1 260 1852)', cxB: 480.71, cyB: 300.62, rB: 10.29, cxW: 480.71, cyW: 300.62, rW: 5.29, x1: 0, y1: 0, x2: 0, y2: 0, status: true, class: "indicator_canadas indicator_letter" },
                { id: 323, text: '1', transform: 'matrix(1 0 0 1 300 1622)', cxB: 480.71, cyB: 300.62, rB: 10.29, cxW: 480.71, cyW: 300.62, rW: 5.29, x1: 402, y1: 1620.62, x2: 780, y2: 1620.62, status: true, class: "indicator_canadas" },
                { id: 324, text: '2', transform: 'matrix(1 0 0 1 300 1342)', cxB: 480.71, cyB: 300.62, rB: 10.29, cxW: 480.71, cyW: 300.62, rW: 5.29, x1: 402, y1: 1340.62, x2: 780, y2: 1340.62, status: true, class: "indicator_canadas" },
                { id: 325, text: '3', transform: 'matrix(1 0 0 1 300 1050)', cxB: 480.71, cyB: 300.62, rB: 10.29, cxW: 480.71, cyW: 300.62, rW: 5.29, x1: 402, y1: 1060.62, x2: 780, y2: 1060.62, status: true, class: "indicator_canadas" },
                { id: 326, text: '4', transform: 'matrix(1 0 0 1 300 772)', cxB: 480.71, cyB: 300.62, rB: 10.29, cxW: 480.71, cyW: 300.62, rW: 5.29, x1: 402, y1: 780.62, x2: 780, y2: 780.62, status: true, class: "indicator_canadas" },
                { id: 327, text: 'PB', transform: 'matrix(1 0 0 1 260 1852)', cxB: 480.71, cyB: 300.62, rB: 10.29, cxW: 480.71, cyW: 300.62, rW: 5.29, x1: 0, y1: 0, x2: 0, y2: 0, status: true, class: "indicator_canadas indicator_letter" },
                { id: 328, text: '1', transform: 'matrix(1 0 0 1 300 1622)', cxB: 480.71, cyB: 300.62, rB: 10.29, cxW: 480.71, cyW: 300.62, rW: 5.29, x1: 402, y1: 1620.62, x2: 780, y2: 1620.62, status: true, class: "indicator_canadas" },
                { id: 329, text: '2', transform: 'matrix(1 0 0 1 300 1342)', cxB: 480.71, cyB: 300.62, rB: 10.29, cxW: 480.71, cyW: 300.62, rW: 5.29, x1: 402, y1: 1340.62, x2: 780, y2: 1340.62, status: true, class: "indicator_canadas" },
                { id: 330, text: '3', transform: 'matrix(1 0 0 1 300 1050)', cxB: 480.71, cyB: 300.62, rB: 10.29, cxW: 480.71, cyW: 300.62, rW: 5.29, x1: 402, y1: 1060.62, x2: 780, y2: 1060.62, status: true, class: "indicator_canadas" },
                { id: 331, text: '4', transform: 'matrix(1 0 0 1 300 772)', cxB: 480.71, cyB: 300.62, rB: 10.29, cxW: 480.71, cyW: 300.62, rW: 5.29, x1: 402, y1: 780.62, x2: 780, y2: 780.62, status: true, class: "indicator_canadas" },

            ],
            //add loading
            loading: false,
            loadFilters: false
        };
    },
    computed: {
        ...mapGetters({
            locations: "getLocations",
            filterModelos: "getStatusFilterModelos"
        }),
        development() {
            return { id: this.id, level: this.levelId };
        },
        img() {
            const torre = this.$route.params.torre;
            const torreSeleccionada = this.torres[torre];
            return torreSeleccionada;
        },
        amountAvailables() {
            const filteredAvailables = this.existFilter;
            const newArrfiltered = filteredAvailables.filter(
                (item) => item.status == 2
            );
            return newArrfiltered;
        },
        existFilter() {
            return this.locations
        },
        detailM() {
            return this.detail
        },
        loadElement() {
            return this.loading
      },
        rangeFilterPrice() {
        if (this.locations.length === 0) {
            return [0, 0];
        }
        // Extraer todos los precios del array pricesList
        const prices = this.locations
            .flatMap(location => location.pricesList || [])
            .map(price => parseFloat(price))
            .filter(price => price > 0);
        if (prices.length === 0) {
            return [0, 0];
        }
        const minPrice = Math.min(...prices);
        const maxPrice = Math.max(...prices);
        return [minPrice, maxPrice + 1];
    },
    rangeFilterPrices() {
        if (this.locations.length === 0) {
            return {};
        }
        // Agrupar pricesList por name (NIVEL 0, NIVEL 1, etc.)
        const pricesByLevel = {};
        this.locations.forEach(location => {
            const level = location.name || 'NIVEL 0'; // name contiene "NIVEL 0", "NIVEL 1", etc.
            const prices = location.pricesList || [];
            if (prices.length > 0) {
                pricesByLevel[level] = prices;
            }
        });
        return pricesByLevel;
    },
    },
    methods: {
        ...mapActions(["getTowerStageLevels", "clearCoords", "getFilterModelos", "clearDpt"]),
        changeRange(arrFilter) {
            this.arrFilteredLocations = arrFilter;
        },
        updateActiveModel(model) {
            this.getFilterModelos(model);
        },
        showDetailPiso() {
            this.detail = false;
            setTimeout(() => {
                this.loading = true
            }, 100);
            setTimeout(() => {
                this.loading = false
            }, 3000);
            setTimeout(() => {
                this.detailPiso = true;
            }, 3500);
        },
        hideDetailPiso() {
            this.detailPiso = false;
        },
        showDetail() {
            this.detail = true;
        },
        hideDetail() {
            this.detailPiso = false
            this.detail = false;
        },
        loadingFilters() {
            setTimeout(() => {
                this.loadFilters = true
            }, 1000);
        }
    },
    async created() {
        await this.getTowerStageLevels(this.development);
        this.getFilterModelos(this.existFilter)
        this.loadingFilters();
    },
    async beforeDestroy() {
        await this.clearCoords();
        await this.clearDpt();
    },
    mounted() {
        this.detail = false
    }
};
</script>
<style>
.st1.st2.aparece.indicator_canadas {
    font-size: 10rem;
}

.st1.st2.aparece.indicator_canadas.indicator_letter {
    font-size: 8.5rem;
}

.canadas_line .st3.torreai {
    stroke-width: 9;
}
</style>
